'use client';
import { useState, useEffect } from 'react';
import { useBodyScrollLock } from '@financial/common-hooks';
import clsx from 'clsx';
import { OverlayContainer } from './OverlayContainer.mjs';
import { jsx } from 'react/jsx-runtime';

const BACKGROUND_COLOR = {
  BLACK: 'bg-black',
  WHITE: 'bg-white'
};

/**
 * @description 레이어 등 화면을 가리는 컴포넌트를 표시할 때 함께 표시되는 반투명한 뒷 배경
 * @typedef shouldShow
 * @typedef onClick 클릭하면 호출할 함수
 * @typedef preventBackgroundScroll  배경 스크롤을 잠글 것인지 여부, 기본값은 true
 * @typedef opacity 불투명도(0~1), 기본값은 0.5
 * @typedef duration
 * @typedef backgroundColor 배경색 (흰색, 검은색), 기본값은 검은색
 * @typedef zIndex overlay의 z-index 값
 * */

const TRANSITION = {
  ENTER: 'enter',
  LEAVE: 'leave'
};
const getDataAttr = (element, attributeName) => element.dataset[attributeName];
function Overlay(_ref) {
  let {
    isShow,
    onClick,
    preventBackgroundScroll = true,
    opacity = 0.5,
    duration = 0,
    backgroundColor = BACKGROUND_COLOR.BLACK,
    zIndex
  } = _ref;
  const [isRunning, setIsRunning] = useState(false);
  const [direction, setDirection] = useState(TRANSITION.LEAVE);
  const handleTransitionEnd = e => {
    if (getDataAttr(e.currentTarget, 'direction') === TRANSITION.LEAVE) {
      setIsRunning(false);
    }
  };
  const isTransition = duration > 0;
  const isLockBodyScroll = isShow && preventBackgroundScroll;
  useBodyScrollLock(isLockBodyScroll);
  useEffect(() => {
    if (isShow) {
      setIsRunning(true);
      requestAnimationFrame(() => setDirection(TRANSITION.ENTER));
    } else {
      requestAnimationFrame(() => setDirection(TRANSITION.LEAVE));
    }
  }, [isShow]);
  if (isTransition) {
    return isRunning ? /*#__PURE__*/jsx(OverlayContainer, {
      className: clsx(direction, backgroundColor),
      "data-direction": direction,
      onTransitionEnd: handleTransitionEnd,
      onClick: onClick,
      style: {
        opacity,
        zIndex
      }
    }) : null;
  }
  return isShow ? /*#__PURE__*/jsx(OverlayContainer, {
    style: {
      opacity,
      zIndex
    },
    className: clsx(backgroundColor),
    onClick: onClick
  }) : null;
}

export { BACKGROUND_COLOR, Overlay as default };
